/*
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

/* global urlHistory, Promise */

/**
 * Creates <i>RestTable</i> and <i>RestEdit</i> by <i>rest</i>,
 * link them together and append them to <i>view</i>
 * @param {Object} view CONTENT.*
 * @param {Rest} rest
 * @param {Object} data
 * If you just created this, optionaly set an id here to instantly load an subject.
 * @returns {RestView}
 * Provides some attributes to lookup. Do not not update them yourself.
 */
function RestView(view, rest, data) {
  if (!this instanceof RestView) return new RestView(view, rest, {});

  data = data || {};
  const that = this;

  // -- attributes --
  this._view = view;
  this._rest = rest;
  this._restTable = new RestTable(this._rest);
  this._restEdit = new RestEdit(this._rest);
  this._subject = null;
  this.destroy = destroy;

  //redirect RestTable click to RestEdit
  this._restTable.onclick = (row) => {
    urlHistory.push(view, { id: row.id });
    loadSubject(row);
  };

  //redirect RestTable new instance creation to RestEdit
  this._restTable.oncreate = (newInstance) => {
    urlHistory.push(view, { id: "new" });
    this._restEdit.loadSubject(newInstance);
    that._subject = newInstance;
  };

  //redirect RestEdit changes to RestTable (use server state)
  this._restEdit.onchange = () => this._restTable.refresh();

  this._restEdit.onclose = () => {
    that._subject = null;

    if (data.id !== undefined) {
      history.back();
      return;
    }
    urlHistory.pop();
  };

  //append RestTable and RestEdit to view node
  document.getElementById(this._view.css_id).appendChild(this._restTable.node);
  document.getElementById(this._view.css_id).appendChild(this._restEdit.node);

  // refresh material tabs!
  componentHandler.upgradeElement(this._restEdit.node);
  componentHandler.upgradeElement(this._restTable.node);

  //capture data.id
  if (data.id) {
    //replace history state to avoid showing TestTable by history.back
    urlHistory.replace(view, { id: data.id });
    loadSubject(data, { noAnimation: true });
  }

  function loadSubject(data, options) {
    if (data.id === "new") {
      that._subject = that._rest.createEmptyInstance();
      const promises = [];

      for (let key in that._rest.schemaData) {
        const schemaItem = that._rest.schemaData[key];
        const val = data[key];
        if (val === undefined) continue;

        switch (schemaItem.type) {
          case "collection":
            const instanceCollection = that._subject.data[key];
            if (Array.isArray(val)) {
              let i = 0;
              const len = val.length;
              for (; i < len; i++)
                promises.push(instanceCollection.add(val[i].id));
            } else {
              promises.push(instanceCollection.add(val.id));
            }
            break;
          default:
            promises.push(
              new Promise((resolve) => {
                that._subject.data[key] = val;
                return resolve();
              })
            );
        }
      }

      return Promise.all(promises).then(() => {
        that._restEdit.loadSubject(that._subject, options);
      });
    }

    that._rest.findOne(data.id).then((instance) => {
      that._subject = instance;
      that._restEdit.loadSubject(that._subject, options);
    });
  }

  /**
   * Try to remove as many as possible pointers to make the work for the gc easer
   * and possibly remove deadlocks.
   * @returns {Promise}
   */
  function destroy() {
    const promises = [];

    promises.push(that._restTable.destroy);
    promises.push(that._restEdit.destroy);

    for (let i in that) that[i] = null;

    return Promise.all(promises);
  }
}
